export default __webpack_public_path__ + "static/media/b7.45696183.png";